import { gql } from "@apollo/client";

export const GET_COUNTRY_STATES = gql`
  query GetCountryStates($countryCode: String!) {
    country(id: $countryCode) {
      id
      two_letter_abbreviation
      three_letter_abbreviation
      full_name_locale
      full_name_english
      available_regions {
        id
        code
        name
        __typename
      }
      __typename
    }
  }
`;
